export const VIEWPORT_BODY_VISIBILITY_EVENT = "viewport-body-visibility";
export const VIEWPORT_CAMERA_VISIBILITY_EVENT = "viewport-camera-visibility";

export function dispatchViewportCameraVisibility(visible) {
  window.dispatchEvent(
    new CustomEvent(VIEWPORT_CAMERA_VISIBILITY_EVENT, { detail: { visible: !!visible } })
  );
}
